import esContent from './studio.es';

export default {
  ...esContent,
};
